import i18next from 'i18next';
import { locales } from 'configs/i18n';

/* ------------------------------ English ------------------------------ */
i18next.addResources(locales.EN, 'JEWISHNESS_SHOW', {
  TITLE: 'Jewishness Certificate Form',
  PERSON: 'Person',
  SPOUSE: 'Spouse',
  PARENTS: 'Parents',
  GRANDPARENTS: 'Grandparents',
  WITNESSES: 'Witnesses',
  COMMENTS: 'Comments',
  PERSON_INFORMATION: 'Person information',
  SPOUSE_INFORMATION: 'Spouse information',
  PERSON_PARENTS_INFORMATION: 'Parents information',
  PERSON_GRANDPARENTS_INFORMATION: 'Grandparents information',
  PERSON_WITNESSES_INFORMATION: 'Witnesses information',
  FIRST_NAME: 'First names',
  LAST_NAME: 'Last names',
  ID_CARD_TYPE: 'ID card type',
  ID_CARD: 'ID card',
  ID_CARD_FILE: 'ID card file',
  ID_CARD_BACK_FILE: 'ID card back file',
  AGE: 'Age',
  COUNTRY: 'Country',
  CIVIL_STATE: 'Civil state',
  BIRTHDATE: 'Birthdate',
  AREA_CODE: 'Area code',
  PHONE: 'Phone',
  TRIBE: 'Cohen, Levi or Israel',
  BIRTH_CERTIFICATE_FILE: 'Birth certificate',
  KETUBA_FILE: 'Ketubá',
  MARRIAGE_CERTIFICATE_FILE: 'Marriage certificate',
  GET_FILE: 'Get',
  CEMENTERY_BURIAL_CERTIFICATE_FILE: 'Cementery burial certificate',
  EMAIL: 'Email',
  COMMUNITY: 'Community',
  ADDRESS: 'Address',
  ALIVE: 'Is alive?',
  YES: 'Yes',
  NO: 'No',
  CEMENTERY: 'Cementery',
  FATHER_LAST_NAME: 'Father last name',
  MOTHER_LAST_NAME: 'Mother last name',
  FATHER_FIRST_NAME: 'Father first name',
  MOTHER_FIRST_NAME: 'Mother first name',
  WEDDING_PLACE: 'Place where they were married',
  WEDDING_DATE: 'Jupa wedding date',
  PATERNAL_FATHER_LAST_NAME: 'Paternal father last name',
  PATERNAL_FATHER_FIRST_NAME: 'Paternal father first name',
  PATERNAL_MOTHER_LAST_NAME: 'Paternal mother last name',
  PATERNAL_MOTHER_FIRST_NAME: 'Paternal mother first name',
  MATERNAL_FATHER_LAST_NAME: 'Maternal father last name',
  MATERNAL_FATHER_FIRST_NAME: 'Maternal father first name',
  MATERNAL_MOTHER_LAST_NAME: 'Maternal mother last name',
  MATERNAL_MOTHER_FIRST_NAME: 'Maternal mother first name',
  BIRTHPLACE: 'Birthplace',
  WITNESS_NAME: 'Full name of the witness',
  LOADING: 'Loading...',
});

/* ------------------------------ Spanish ------------------------------ */
i18next.addResources(locales.ES, 'JEWISHNESS_SHOW', {
  TITLE: 'Formulario de Judeidad',
  PERSON: 'Persona',
  SPOUSE: 'Cónyuge',
  PARENTS: 'Padres',
  GRANDPARENTS: 'Abuelos',
  WITNESSES: 'Testigos',
  COMMENTS: 'Observaciones',
  PERSON_INFORMATION: 'Información de la persona',
  SPOUSE_INFORMATION: 'Información del/la cónyuge',
  PERSON_PARENTS_INFORMATION: 'Información de los padres',
  PERSON_GRANDPARENTS_INFORMATION: 'Información de los abuelos',
  PERSON_WITNESSES_INFORMATION: 'Información de los testigos',
  FIRST_NAME: 'Nombres',
  LAST_NAME: 'Apellidos',
  ID_CARD_TYPE: 'Tipo de documento',
  ID_CARD: 'Documento',
  ID_CARD_FILE: 'Documento frente (escaneado)',
  ID_CARD_BACK_FILE: 'Documento dorso (escaneado)',
  AGE: 'Edad',
  COUNTRY: 'País',
  CIVIL_STATE: 'Estado civil',
  BIRTHDATE: 'Fecha de nacimiento',
  AREA_CODE: 'Código de área',
  PHONE: 'Celular',
  TRIBE: 'Cohen, Levi o Israel',
  BIRTH_CERTIFICATE_FILE: 'Partida de nacimiento',
  KETUBA_FILE: 'Ketubá',
  MARRIAGE_CERTIFICATE_FILE: 'Libreta de casamiento',
  GET_FILE: 'Get',
  CEMENTERY_BURIAL_CERTIFICATE_FILE: 'Constancia de inhumación de cementerio',
  EMAIL: 'Email',
  COMMUNITY: 'Comunidad',
  ADDRESS: 'Domicilio',
  ALIVE: 'Está con vida?',
  YES: 'Si',
  NO: 'No',
  CEMENTERY: 'Cementerio',
  FATHER_LAST_NAME: 'Apellido del padre',
  MOTHER_LAST_NAME: 'Apellido de la madre',
  FATHER_FIRST_NAME: 'Nombre del padre',
  MOTHER_FIRST_NAME: 'Nombre de la madre',
  WEDDING_PLACE: 'Lugar donde se casaron',
  WEDDING_DATE: 'Fecha de casamiento de jupá',
  PATERNAL_FATHER_LAST_NAME: 'Apellido del abuelo paterno',
  PATERNAL_FATHER_FIRST_NAME: 'Nombre del abuelo paterno',
  PATERNAL_MOTHER_LAST_NAME: 'Apellido de la abuela paterna',
  PATERNAL_MOTHER_FIRST_NAME: 'Nombre de la abuela paterna',
  MATERNAL_FATHER_LAST_NAME: 'Apellido del abuelo materno',
  MATERNAL_FATHER_FIRST_NAME: 'Nombre del abuelo materno',
  MATERNAL_MOTHER_LAST_NAME: 'Apellido de la abuela materna',
  MATERNAL_MOTHER_FIRST_NAME: 'Nombre de la abuela materna',
  BIRTHPLACE: 'Lugar de nacimiento',
  WITNESS_NAME: 'Nombre completo del testigo',
  LOADING: 'Cargando...',
});
